module.exports = __webpack_public_path__ + "static/media/mckeon-group.aa8f4c05.png";